@import '~style-sheet-helpers/core.less';

.dropdown-menu-title-with-label {
  width: 100%;
  height: 40px;
  padding-top: 4px;
}

.label,
.title {
  .truncate();
  max-width: 100%;
}

.label {
  font-size: 10px;
  opacity: 0.75;
  line-height: 13px;
}

.title {
  font-size: 15px;
  line-height: 19px;
}

.required-indicator {
  position: absolute;
  top: -1px;
  right: 0;
}
